module.exports = __webpack_public_path__ + "assets/img/e-book.dda7f4b2.png";